"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const CustomerSupportIcon = createSVGIcon(
  <>
    <path
      d="M5.89709 13.7145V10.8688C5.94814 8.2397 7.04096 5.73844 8.93539 3.91474C10.8298 2.09103 13.3708 1.09411 16 1.14308V1.14308C18.6291 1.09411 21.1701 2.09103 23.0645 3.91474C24.9589 5.73844 26.0518 8.2397 26.1028 10.8688V13.7145"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.42829 13.7141H6.85686C7.15997 13.7141 7.45066 13.8345 7.66499 14.0488C7.87931 14.2632 7.99972 14.5539 7.99972 14.857V21.1427C7.99972 21.4458 7.87931 21.7365 7.66499 21.9508C7.45066 22.1651 7.15997 22.2855 6.85686 22.2855H3.42829C2.82208 22.2855 2.2407 22.0447 1.81205 21.6161C1.38339 21.1874 1.14258 20.606 1.14258 19.9998V15.9998C1.14258 15.3936 1.38339 14.8122 1.81205 14.3836C2.2407 13.9549 2.82208 13.7141 3.42829 13.7141V13.7141Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.5717 22.2859H25.1431C24.84 22.2859 24.5493 22.1655 24.335 21.9512C24.1207 21.7368 24.0003 21.4461 24.0003 21.143V14.8573C24.0003 14.5542 24.1207 14.2635 24.335 14.0492C24.5493 13.8349 24.84 13.7145 25.1431 13.7145H28.5717C29.1779 13.7145 29.7593 13.9553 30.188 14.3839C30.6166 14.8126 30.8574 15.394 30.8574 16.0002V20.0002C30.8574 20.6064 30.6166 21.1878 30.188 21.6164C29.7593 22.0451 29.1779 22.2859 28.5717 22.2859V22.2859Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3483 28.5716C22.5848 28.5955 23.7803 28.1274 24.6718 27.2701C25.5633 26.4129 26.0779 25.2367 26.1026 24.0002V24.0002V22.2859"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2174 26.2859H21.3488V30.8573H14.2174V26.2859Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CustomerSupportIcon",
  {
    viewBox: "0 0 32 32",
    fill: "none",
    color: "#888888",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
